"use strict";

// 3rd party dependency
import angular from "angular";

// alk dependency
import FleetViewConfig from "./fleetview.config";
import FleetViewDashboard from "./fleetview.dashboard";
import FleetViewAPI from "./fleetview.api";
import RouteReporterConfig from "./routereporter.config";
import RouteReporterAPI from "./routereporter.api";

export default angular.module("alk.fleetview", [])
  .constant("alk.fleetview.config", FleetViewConfig)
  .service("FleetViewDashboard", FleetViewDashboard)
  .service("FleetViewAPI", FleetViewAPI)
  .constant("alk.routereporter.config", RouteReporterConfig)
  .service("RouteReporterAPI", RouteReporterAPI)
  .name;



// WEBPACK FOOTER //
// ./app/alk-fleetview/index.js